// extracted by mini-css-extract-plugin
export default {"root":"TerminationWarning_root__Clss0","link":"TerminationWarning_link__RYscx"};